import * as React from 'react';

interface IProps {
    message: string;
}

export const PageLevelError = (props: IProps) => (
    
    <p className="page-level-feedback">
        <span className="la la-asterisk" />
        { props.message }
    </p> 
    
);
